export { default } from 'components/Page/Page'
